export default "__VITE_ASSET__d7dd86fb__"